import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  Redirect
} from "react-router-dom";
import ReactDOM from "react-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import "./index.css";

import { getPosts, getPages, getBlogInfo } from "./components/fetch/fetchApi";

import Preloader from "./components/Preloader";

import NotFound from "./components/NotFound";

import Project from "./components/Project";
import Categories from "./components/Categories";
import ContactPage from "./components/ContactPage";
import About from "./components/About";

import Button from "./components/Button";

import "./App.css";

class Root extends Component {
  constructor() {
    super();

    this.getWPPosts = this.getWPPosts.bind(this);
    this.removePreloader = this.removePreloader.bind(this);
    this.fetchNewPosts = this.fetchNewPosts.bind(this);
    this.handleScroll = this.handleScroll.bind(this);

    this.scrollcount = 1;
    this.processing;

    this.state = {
      pageData: [],
      blogInfo: {},
      postData: {},
      preloader: true,
      scrollPreloader: false
    };
  }

  componentWillMount() {
    window.addEventListener("scroll", this.handleScroll);

    if (this.state.pageData.length === 0) {
      var pages;
      // pages.then((pageData) => {
      //   this.setState({pageData});
      // });
    }

    if (Object.keys(this.state.postData).length === 0) {
      var posts = getPosts();
      posts.then(postData => {
        this.setState({ postData });
      });
    }

    if (Object.keys(this.state.blogInfo).length === 0) {
      var blogInfo = getBlogInfo();
      blogInfo.then(blogInfo => {
        this.setState({ blogInfo });
      });
    }

    Promise.all([posts, pages, blogInfo]).then(() => {
      this.removePreloader();
    });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll(event) {
    if (!this.processing) {
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight * 0.75
      ) {
        this.processing = true;
        this.scrollcount = this.scrollcount + 1;
        this.setState({ scrollPreloader: true });
        this.fetchNewPosts(this.scrollcount);
      }
    }
  }

  fetchNewPosts(count) {
    var posts = getPosts(count);

    posts.then(postData => {
      if (typeof postData !== "undefined") {
        this.processing = false;
        this.setState({ postData: this.state.postData.concat(postData) });
        this.setState({ scrollPreloader: false });
      } else {
        console.log("remove handler end of posts");
        window.removeEventListener("scroll", this.handleScroll);
        this.setState({ scrollPreloader: false });
      }
    });
  }

  getWPPosts() {
    let wp_posts = "";
    if (this.state.postData != undefined && this.state.postData.length >= 1) {
      wp_posts = this.state.postData.map(el => {
        return el;
      });
    }
    return wp_posts;
  }

  removePreloader() {
    this.setState({ preloader: false });
  }

  render() {
    this.getWPPosts();
    return (
      <Router>
        <div className="wrapper">
          <Preloader {...this.state} />
          <Switch>
            <Route
              path="/"
              {...this.state}
              exact
              render={() => {
                return <App {...this.state} />;
              }}
            />
            <Route
              path="/project/:projectid"
              render={props => {
                return <Project {...this.state} url={props} />;
              }}
            />
            <Route
              path="/projects/:categoryid"
              render={props => {
                return <Categories {...this.state} url={props} />;
              }}
            />
            <Route path="/contact" component={ContactPage} />
            <Route
              path="/about"
              render={() => {
                return <About {...this.state} />;
              }}
            />
            <Route component={NotFound} />
          </Switch>
        </div>
      </Router>
    );
  }
}

ReactDOM.render(<Root />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js